import { URL_PREFIX } from "@/const/const";

export default class teamGroupServer {

    // 获取用户加入的团队列表
    static API_GET_USER_TEAM_LIST = URL_PREFIX + "/teams/joined";

    // 最后一次打开的团队
    static API_GET_LAST_TEAM_DETAIL = URL_PREFIX + "/teams/detail";

    // 创建团队
    static API_CREATE_TEAM = URL_PREFIX + "/teams/create";

    // 退出团队
    static API_DELETE_TEAM_BY_TEAMID = URL_PREFIX + "/teams/{teamId}/members/leave";

    // 更新团队信息
    static API_POST_UPDATE_TEAM = URL_PREFIX + "/teams/update";

    // 获取团队成员列表
    static API_GET_TEAM_MEMBERS = URL_PREFIX + "/teams/{teamId}/members";

    // 移除团队成员
    static API_DELETE_TEAM_MEMBER = URL_PREFIX + "/teams/{teamId}/members";

    // 获取数据字典
    static API_GET_BASE_DICT = URL_PREFIX + "/dict";

    // 更新用户信息
    static API_POST_UPDATE_USER_INFO = URL_PREFIX + "/teams/{teamId}/members";

    // 邀请新成员
    static API_POST_INVITE_MEMBER = URL_PREFIX + "/teams/{teamId}/members/invitation";

    // 接受邀请
    static API_PUT_ACCEPTED_INVITATION  = URL_PREFIX + "/teams/invitations/{invitationId}/accept";

    // 获取邀请详情
    static API_GET_INVITATION_DETAIL = URL_PREFIX + "/teams/invitations/{invitationId}";

    // 查询团队存储统计信息
    static API_GET_TEAM_STORAGE = URL_PREFIX + "/user/storage";

    static API_GET_TEAM_DATA_LOG = URL_PREFIX + "/teams/{teamId}/logs";

    // 移交团队管理员
    static API_POST_TRANSFER_TEAM = URL_PREFIX + "/teams/{teamId}/transfer";

    static API_PUT_MERGE_TEAM= URL_PREFIX + "/teams/merge";
    
}